import type { ReactNode } from 'react'
import { APIProvider } from '@vis.gl/react-google-maps'
import { GOOGLE_MAPS_API_KEY } from '@/lib/googleMaps'

interface GoogleMapsProviderProps {
  children: ReactNode
}

/**
 * The single canonical `<APIProvider>` configuration.
 *
 * Every map surface mounts this instead of `<APIProvider>` directly. vis.gl loads the
 * bootstrap script once per page from whichever provider mounts first; a second mount
 * carrying different parameters is silently ignored, so two surfaces disagreeing about
 * `language` or `region` would give one of them a configuration it never asked for.
 *
 * `language` is pinned rather than inferred from the browser locale: the tracking map is
 * rendered inside a forced-LTR container (Google's `.gm-style` internals are positioned
 * from `left` and inherit `direction`), and an Arabic locale would put Google's own RTL
 * control layout inside that LTR box — two competing direction contexts.
 */
export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY} language="en" region="SA">
      {children}
    </APIProvider>
  )
}
